import { BaseController } from '../../../../../../../common/base/controller';
import { MODEL_FIELDS } from '../../confirmWarrant.model';
import { IGNORE_PAYMENT_PARTNER_FIELDS } from './accountswitchOptions.fields';

const ADDITIONAL_ACCOUNT_OWNERS_FIELD = MODEL_FIELDS.additionalAccountOwners;

export class AccountswitchOptionsController extends BaseController {
  constructor($scope, $compile, controllerService, SepaCountries) {
    'ngInject';
    super({
      $scope,
      $compile,
      controllerService,
      SepaCountries,
    });
  }

  getLabelFor(field) {
    return `${this.translatePrefix}.${field}`;
  }

  addAdditionalAccountOwners() {
    const field = ADDITIONAL_ACCOUNT_OWNERS_FIELD;
    if (this.model[field].length >= 3) {
      return;
    }
    this.model[field].push({
      [MODEL_FIELDS.firstName]: '',
      [MODEL_FIELDS.lastName]: '',
    });
  }

  removeAdditionalAccountOwner(index) {
    const field = ADDITIONAL_ACCOUNT_OWNERS_FIELD;
    this.model[field].splice(index, 1);
  }

  inputMessagesFor(field) {
    return {
      required: `${this.translatePrefix}.error.required.${field}`,
      iban: `${this.translatePrefix}.error.iban.${field}`,
      type: `${this.translatePrefix}.error.type.${field}`,
    };
  }

  $onInit() {
    this.MODEL_FIELDS = MODEL_FIELDS;
    this.ignorePaymentPartnerFieldDefinition = [IGNORE_PAYMENT_PARTNER_FIELDS];

    this.fieldOptions = { filterCountries: this.SepaCountries.list };

    this.ibanInputOptions = { type: 'text', validate: 'iban' };
    this.oldIbanMessages = this.inputMessagesFor(this.MODEL_FIELDS.oldIban);
    this.newIbanMessages = this.inputMessagesFor(this.MODEL_FIELDS.newIban);

    const field = ADDITIONAL_ACCOUNT_OWNERS_FIELD;
    if (!this.model[field]) {
      this.model[field] = [];
    }
  }
}
